import React from 'react';
import { BadgePercent, BarChart3, TicketPercent, Users } from 'lucide-react';
import Dash from '@dashboard/components/Dash';
import * as KPICard from '@dashboard/scenes/PageOverview/components/KPICard';
import getPriceLabel from '@dashboard/services/translation/getPriceLabel';

const moneyLabel = totals =>
  totals?.length ? totals.map(total => getPriceLabel(total)).join(' + ') : <Dash />;

const Stat = ({ icon, title, tooltip, children }) => (
  <KPICard.Container>
    <KPICard.Icon icon={icon} />
    <KPICard.Header>
      <KPICard.Title>{title}</KPICard.Title>
      <KPICard.InfoTooltip>{tooltip}</KPICard.InfoTooltip>
    </KPICard.Header>
    <KPICard.Value>{children}</KPICard.Value>
  </KPICard.Container>
);

const CouponStats = ({ coupon }) => {
  const stats = coupon.stats ?? { customers: 0, revenue: [], discount: [] };
  const redemptions = coupon.timesRedeemed ?? 0;

  return (
    <div className="grid gap-2 md:grid-cols-4">
      <Stat
        icon={TicketPercent}
        title="Redemptions"
        tooltip="Times this coupon was used on a live order or subscription, out of its max uses"
      >
        {redemptions}
        {coupon.maxRedemptions != null && `/${coupon.maxRedemptions}`}
      </Stat>
      <Stat icon={Users} title="Customers" tooltip="Different customers who used this coupon">
        {stats.customers}
      </Stat>
      <Stat
        icon={BarChart3}
        title="Revenue"
        tooltip="Paid on orders and subscription renewals that used this coupon, after refunds. Each currency is shown separately"
      >
        {moneyLabel(stats.revenue)}
      </Stat>
      <Stat
        icon={BadgePercent}
        title="Discount given"
        tooltip="Taken off one-time payments and bookings. Subscription renewals aren't included"
      >
        {moneyLabel(stats.discount)}
      </Stat>
    </div>
  );
};

export default CouponStats;
